const SourceType = Object.freeze({
  OTHER: 'Other',
  PATENTS: 'Patents',
  JOURNALS: 'Journals',
  SHOPPING: 'Shopping',
  BLOGS: 'Blogs',
  FORUMS: 'Forums',
  SUBREDDITS: 'SubReddits',
  NEWS: 'News',
  BROADCAST: 'Broadcast',
  PODCAST: 'Podcast',
  EDUCATION: 'Education',
  GOVERNMENT: 'Government',
  ORGANIZATION: 'Organization',
  COMPANY: 'Company',
  SOCIAL_NETWORKS: 'SocialNetworks',
  MICROBLOGS: 'Microblogs',
  PROF_REVIEWS: 'ProfReviews',
  COMMENTS: 'Comments',
  CONSUMER_REVIEWS: 'ConsumerReviews',
  TWITTER: 'Twitter',
  TIKTOK: 'TikTok',
  INTERNAL: 'Internal',
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
  YOUTUBE: 'YouTube',
  BLUESKY: 'Bluesky'
})
export default SourceType
export type SourceTypeStrings = typeof SourceType[keyof typeof SourceType]
// RESERVE BELOW
